module.exports = __webpack_public_path__ + "img/eg1.79bc9175.png";